// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class Ansi837MedicalClaimResponseModel {
    'stagingId': number;
    'claimCaseId': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof Ansi837MedicalClaimResponseModel>> = [
        {
            "name":     "stagingId",
            "baseName": "stagingId",
            "type":     "number"
        },
        {
            "name":     "claimCaseId",
            "baseName": "claimCaseId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return Ansi837MedicalClaimResponseModel.attributeTypeMap;
    }
}
